/* Live & Socials (Live section) — takes the live banner from the staff console (worker), not the theme editor */
(function () {
  var sec = document.getElementById("pullsSection");
  var mount = document.getElementById("liveMount");
  if (!sec || !mount) return;
  var W = (sec.getAttribute("data-worker") || "").replace(/\/$/, "");
  if (!W) return;

  var channels = [];
  try { channels = JSON.parse(mount.getAttribute("data-channels") || "[]"); } catch (e) { channels = []; }
  var esc = function (v) { var d = document.createElement("i"); d.textContent = v == null ? "" : String(v); return d.innerHTML; };
  var find = function (name) {
    for (var i = 0; i < channels.length; i++) {
      if (channels[i].name && channels[i].name.toLowerCase() === String(name).toLowerCase()) return channels[i];
    }
    return null;
  };

  function paint(s) {
    var existing = sec.querySelector(".live-bar");
    var html;
    if (s.live) {
      var chips = (s.platforms || []).map(function (p) {
        var c = find(p);
        var url = c ? (c.live_url || c.url || "#") : "#";   // the live stream, not the profile
        return '<a class="live-chip" href="' + esc(url) + '" target="_blank" rel="noopener" style="--chan:' +
          esc((c && c.accent) || "#FFB627") + '"><span class="live-chip-dot" aria-hidden="true"></span>' + esc(p) + "</a>";
      }).join("");
      var sub = (s.platforms && s.platforms.length > 1)
        ? "Streaming on " + s.platforms.length + " platforms — pick your favorite"
        : (s.platforms && s.platforms.length === 1 ? "on " + esc(s.platforms[0]) : "");
      html =
        '<div class="live-bar is-on">' +
          '<span class="live-badge"><span class="live-dot" aria-hidden="true"></span>Live now</span>' +
          '<span class="live-txt"><b>' + esc(s.title || "We are ripping right now") + "</b>" +
            (sub ? "<span>" + sub + "</span>" : "") + "</span>" +
          (chips ? '<span class="live-links">' + chips + "</span>" : "") +
        "</div>";
    } else {
      html =
        '<div class="live-bar">' +
          '<span class="live-badge off">Offline</span>' +
          '<span class="live-txt"><b>Not live at the moment</b>' +
            (s.next ? "<span>Next up: " + esc(s.next) + "</span>" : "") + "</span>" +
        "</div>";
    }
    if (existing) {
      existing.outerHTML = html;
    } else {
      mount.insertAdjacentHTML("afterend", html);
    }
  }

  function poll() {
    fetch(W + "/live", { cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (s) { if (s && typeof s.live === "boolean") paint(s); })
      .catch(function () {});
  }
  poll();
  setInterval(poll, 60000); // so a visitor sitting on the page sees the stream start
})();
